export default {
  path: '/wecode/apps',
  auth: false,
  preload: false,
  key: 'new-solution',
  // layout: 'outer', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
